module.exports = __webpack_public_path__ + "img/apeed_city@2x.60e565dc.png";